module.exports = __webpack_public_path__ + "static/media/fly0145.fb7d1a20.webp";